<script setup>
import { useVideoStore } from '~~/store/video'
const store = useVideoStore()

const muted = computed(() => store.muted)
function toggleMute() {
  store.muted = !store.muted
}
</script>

<template>
  <button @click="toggleMute" class="volume-control">
    <Icon v-if="muted" name="sound-off" />
    <Icon v-else name="sound" />
  </button>
</template>

<style lang="scss">
.volume-control {
  .icon {
    width: 18px;
  }
}
</style>
